import React from "react";
import { Bar } from "react-chartjs-2";

/* Presentation only — the incoming `chartData` is never mutated, its
   series are re-skinned here so the dashboard owns no chart styling. */

const SERIES = [
  { from: "rgba(43,143,224,0.95)", to: "rgba(28,79,134,0.95)", hover: "#1c4f86" },
  { from: "rgba(25,184,122,0.95)", to: "rgba(15,122,82,0.95)", hover: "#0f7a52" },
  { from: "rgba(245,147,49,0.95)", to: "rgba(199,110,23,0.95)", hover: "#c76e17" },
];

const verticalFill = (context, from, to) => {
  const { ctx, chartArea } = context.chart;
  if (!chartArea) return from;
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0, to);
  gradient.addColorStop(1, from);
  return gradient;
};

const Barchart = (props) => {
  const source = props.chartData || { labels: [], datasets: [] };

  const data = {
    labels: source.labels,
    datasets: (source.datasets || []).map((set, i) => {
      const tone = SERIES[i % SERIES.length];
      return {
        ...set,
        backgroundColor: (context) => verticalFill(context, tone.from, tone.to),
        hoverBackgroundColor: tone.hover,
        borderRadius: { topLeft: 10, topRight: 10, bottomLeft: 3, bottomRight: 3 },
        borderSkipped: false,
        maxBarThickness: 26,
        borderWidth: 0,
      };
    }),
  };

  return (
    <div className="bar-wrap">
      <Bar
        className="mt-2"
        data={data}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          /* grows out of the axis, each bar a beat behind the last */
          animation: {
            duration: 900,
            easing: "easeOutQuart",
            delay: (context) =>
              context.type === "data" && context.mode === "default"
                ? context.dataIndex * 60 + context.datasetIndex * 90
                : 0,
          },
          interaction: { mode: "index", intersect: false },
          layout: { padding: { top: 8 } },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                boxWidth: 8,
                boxHeight: 8,
                padding: 18,
                color: "#64748b",
                font: { family: "Figtree, sans-serif", size: 12.5, weight: "600" },
              },
            },
            tooltip: {
              backgroundColor: "#1e293b",
              padding: 12,
              cornerRadius: 12,
              displayColors: true,
              usePointStyle: true,
              boxPadding: 6,
              titleColor: "#ffffff",
              titleFont: { family: "Figtree, sans-serif", size: 13, weight: "700" },
              bodyColor: "rgba(234,242,251,0.82)",
              bodyFont: { family: "Figtree, sans-serif", size: 12.5 },
            },
          },
          scales: {
            x: {
              border: { display: false },
              grid: { display: false },
              ticks: {
                color: "#94a3b8",
                font: { family: "Figtree, sans-serif", size: 11.5, weight: "600" },
                maxRotation: 0,
                autoSkip: true,
              },
            },
            y: {
              beginAtZero: true,
              border: { display: false, dash: [4, 4] },
              grid: { color: "#eef2f7", drawTicks: false, lineWidth: 1 },
              ticks: {
                color: "#94a3b8",
                padding: 10,
                precision: 0,
                font: { family: "Figtree, sans-serif", size: 11.5 },
              },
            },
          },
        }}
      />
    </div>
  );
}

export default Barchart;
